export const getChange = (onChange, isMulti) => option => {
  if (!isMulti) {
    return onChange(option ? option.value : null)
  }
  return onChange(option.filter(({ value }) => value !== undefined).map(({ value }) => value))
}

export const getValue = (value, isMulti) => {
  if (value === undefined) {
    return isMulti ? [{ label: "all", value: undefined }] : { label: "all", value: undefined }
  } else {
    return value
  }
}
